import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=20f77e0a&scoped=true"
import script from "./detail-content.vue?vue&type=script&lang=js"
export * from "./detail-content.vue?vue&type=script&lang=js"
import style0 from "./detail-content.vue?vue&type=style&index=0&id=20f77e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f77e0a",
  null
  
)

export default component.exports